import React, { ReactElement } from 'react';
import { css, jsx } from '@emotion/react';

interface TruncateProps {
  type: string;
  lines: number;
  className?: string;
  children: React.ReactNode;
}

export const Truncate: React.FC<TruncateProps> = ({
  type,
  lines,
  className,
  children,
}): ReactElement => {
  const style = css`
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    word-break: break-all;
    overflow: hidden;
  `;

  return jsx(
    type,
    {
      css: style,
      className,
    },
    children
  );
};
